// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
// eslint-disable-next-line
import getUsersForUserManagement from '../../utils/api/get/getUsersForUserManagement';
import Tablet from '../../components/layout/tablet';
import { datatableColumnsForUserManagement } from '../../utils/constans';
import DashboardIcon from '../../components/dashboard/icons/DashboardIcon';
import UserManagementActions from '../../components/userManagement/UserManagementActions';

const UserManagement = ({ mainContainer, toggleModal, isReload }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, [isReload]);

  const fetchUsers = async () => {
    toggleModal(true, 'loader');
    const response = await getUsersForUserManagement();
    const newUsers = response.map(user => ({
      _id: user._id,
      id: user._id,
      companyId: user.companyId,
      email: user.email,
      phone: user.phone,
      firstName: user.firstname,
      lastName: user.lastname,
      role: user.accessctrl || 'Manager',
      status: user.status,
    }));
    setUsers(newUsers);
    toggleModal(false, 'loader');
  };

  const openAddUserModal = () => {
    toggleModal(true, 'addOrEditUsersForManagement');
  };

  return (
    <div className="subpage-wrap">
      <div className="subpage-header">
        <h1 className="subpage-title">User Management</h1>
        <button
          className="subpage-btn subpage-btn--gold"
          type="button"
          aria-label="add user"
          onClick={openAddUserModal}
        >
          <DashboardIcon name="plus" size={18} strokeWidth="2.5" />
          Add User
        </button>
      </div>

      <div className="subpage-table-scroll subpage-table-scroll--users">
        <Tablet
          className="subpage-table subpage-table--wide subpage-table--users"
          columns={datatableColumnsForUserManagement}
          rows={users}
          enableActionsCol
          actionsColLabel="Actions"
          ActionElement={UserManagementActions}
          placeholder="No users found"
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, { toggleModal })(UserManagement);
